import { useEffect, useState } from 'react';

export function NetworkStatusBanner() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    const nativeStatus = (event: Event) => setOnline(Boolean((event as CustomEvent<boolean>).detail));
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    window.addEventListener('lspd:network', nativeStatus as EventListener);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('lspd:network', nativeStatus as EventListener);
    };
  }, []);

  if (online) return null;
  return <div className="network-banner" role="status">当前处于离线状态，部分功能可能不可用</div>;
}
